import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiLinearProgressLoader, NoddiSkeleton } from 'noddi-ui-web';

export const PointOfSalePaymentOrderLookupLoading = () => {
  return (
    <div className='flex flex-col gap-4'>
      <NoddiBasicCard className='flex flex-col gap-4'>
        <div className='flex flex-col gap-1'>
          <p className='text-sm font-medium text-primary'>
            <Trans>We are looking up the order for your car.</Trans>
          </p>
          <p className='text-sm text-muted-foreground'>
            <Trans>This might take a while...</Trans>
          </p>
        </div>
        <NoddiLinearProgressLoader />
        <div className='flex items-center justify-between'>
          <NoddiSkeleton className='h-6 w-40' />
          <NoddiSkeleton className='h-6 w-24' />
        </div>

        <div className='flex flex-col gap-2'>
          <NoddiSkeleton className='h-4 w-2/3' />
          <NoddiSkeleton className='h-4 w-1/2' />
          <NoddiSkeleton className='h-4 w-3/5' />
          <NoddiSkeleton className='h-4 w-2/5' />
        </div>

        <div className='flex flex-col gap-2 border-t pt-4'>
          <NoddiSkeleton className='h-4 w-full' />
          <NoddiSkeleton className='h-4 w-5/6' />
          <NoddiSkeleton className='h-4 w-4/6' />
        </div>

        <div className='flex flex-col gap-2 border-t pt-4'>
          <NoddiSkeleton className='h-4 w-1/2' />
          <NoddiSkeleton className='h-4 w-1/2' />
          <NoddiSkeleton className='h-5 w-2/3' />
        </div>
      </NoddiBasicCard>
    </div>
  );
};
